import component from './zh/component';
import globalHeader from './zh/globalHeader';
import menu from './zh/menu';
import pages from './zh/pages';
import pwa from './zh/pwa';
import settingDrawer from './zh/settingDrawer';
import settings from './zh/settings';
import inquiry from './zh/inquiry';

export default {
	'navBar.lang': '语言',
	'layout.user.link.help': '帮助',
	'layout.user.link.privacy': '隐私',
	'layout.user.link.terms': '条款',
	'app.preview.down.block': '下载此页面到本地项目',
	'app.welcome.link.fetch-blocks': '获取全部区块',
	'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
	...pages,
	...globalHeader,
	...menu,
	...settingDrawer,
	...settings,
	...pwa,
	...component,
	...inquiry
};
